import {fullProfileTypes} from "../actions/Dashboard/FullProfile/actionsType";

const initState = {
    current: {},
    playerId: null,
};

const FullProfileReducer = (state = initState, action) => {
    switch (action.type) {
        case "ADD_CURRENT_FULL_PROFILE" : {
            return Object.assign({}, state, {
                current: action.full_profile
            });
        }

        case fullProfileTypes.SET_PLAYER_ID:
            return Object.assign({}, state, {
                playerId: action.playerId
            });

        default: {
            return state;
        }
    }
};

export default FullProfileReducer;
